import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IGenericResult } from 'src/app/models/generic';
import { IParameter, IParamSearch } from 'src/app/models/parameter';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiParameterService {

  baseUrls: { [key: string]: string } = {
    baseUrlContractParams: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.contractParameter}`
  };

  constructor(
    private _http: HttpClient
  ) { }

  getAllParameters(
    searchData: IParamSearch
  ): Observable<IGenericResult<IParameter[]>> {
    return this._http.post<IGenericResult<IParameter[]>>(
      `${this.baseUrls['baseUrlContractParams']}/list`,
      searchData
    );
  }

  getParamById(id: string): Observable<IGenericResult<IParameter>> {
    return this._http.get<IGenericResult<IParameter>>(
      `${this.baseUrls['baseUrlContractParams']}/${id}`
    );
  }

  updateParameter(parameter: IParameter): Observable<IGenericResult<IParameter>> {
    return this._http.put<IGenericResult<IParameter>>(
      //`${environment.apis.contracts.baseUrl}/Parameter/${parameter.ParameterId}`,
      `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.contractParameter}/${parameter.ParameterId}`,
      parameter
    );
  }
}
